/**
 * Утилиты для шаринга в социальные сети
 */

interface ShareOptions {
  title: string;
  text: string;
  url: string;
  image?: string;
}

/**
 * Поделиться через Web Share API (если доступен)
 */
export const shareViaWebAPI = async (options: ShareOptions): Promise<boolean> => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: options.title,
        text: options.text,
        url: options.url,
      });
      return true;
    } catch (error) {
      if ((error as Error).name !== 'AbortError') {
        console.error('Error sharing:', error);
      }
      return false;
    }
  }
  return false;
};

/**
 * Поделиться в Telegram
 */
export const shareToTelegram = (options: ShareOptions): void => {
  const text = encodeURIComponent(`${options.title}\n\n${options.text}`);
  const url = `https://t.me/share/url?url=${encodeURIComponent(options.url)}&text=${text}`;
  window.open(url, '_blank', 'width=600,height=400');
};

/**
 * Поделиться в VK
 */
export const shareToVK = (options: ShareOptions): void => {
  const url = `https://vk.com/share.php?url=${encodeURIComponent(options.url)}&title=${encodeURIComponent(options.title)}&description=${encodeURIComponent(options.text)}`;
  window.open(url, '_blank', 'width=600,height=400');
};

/**
 * Поделиться в Twitter
 */
export const shareToTwitter = (options: ShareOptions): void => {
  const text = encodeURIComponent(`${options.title} - ${options.text}`);
  const url = `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(options.url)}`;
  window.open(url, '_blank', 'width=600,height=400');
};

/**
 * Скопировать ссылку в буфер обмена
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Error copying to clipboard:', error);
    // Fallback для старых браузеров
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch (err) {
      document.body.removeChild(textArea);
      return false;
    }
  }
};
